export default "__VITE_ASSET__DwMHlaNF__"